export const blockIconsHouseholdAcUnitNew = (
	<span className='material-symbols-outlined'>ac_unit</span>
);
